import React, { useState } from 'react'
import { VideoLibraryTab } from './VideoLibraryTab'

import { Tab, Tabs } from '@mui/material'
import { Container } from '../../Container'
import { useTheme } from '@material-ui/core/styles'
import { ProjectPlansTab } from './ProjectPlansTab'
import { TopicsTab } from './TopicsTab'
import { AnalysisTab } from './AnalysisTab'
import { LiveTab } from './LiveTab'
import { useLoriConversationAnalysis } from '../../../hooks/useLoriConversationAnalysis'
import { useTrainingVideo } from '../../../hooks/useTrainingVideo'
import { useProjectPlan } from '../../../hooks/useProjectPlan'
import { useTopics } from '../../../hooks/useTopics'

const tabSx = { textTransform: 'none', marginRight: '12px' } as const

export const LoriManager = () => {
    const theme = useTheme()
    const TrainingVideoController = useTrainingVideo()
    const ProjectPlanController = useProjectPlan()
    const analyticsController = useLoriConversationAnalysis()
    const { topics } = useTopics()

    const ANALYSIS_TAB = 0
    const VIDEO_LIBRARY_TAB = 1
    const PROJECT_PLANS_TAB = 2
    const TOPICS_TAB = 3
    const LIVE_TAB = 4

    const [selectedTab, setSelectedTab] = useState<number>(ANALYSIS_TAB)

    return (
        <Container
            style={{
                borderRadius: theme.shape.borderRadius,
                maxHeight: 'calc(100vh - 100px)',
                minHeight: 'calc(100vh - 100px)',
                maxWidth: 'calc(100vw - 140px)',
                minWidth: 'calc(100vw - 140px)',
                overflow: 'hidden',
                flexDirection: 'column',
                padding: theme.spacing(1),
            }}
        >
            <Container>
                <Tabs
                    value={selectedTab}
                    onChange={(_, newValue) => setSelectedTab(newValue)}
                >
                    <Tab label="Analysis" sx={tabSx} />
                    <Tab label="Video Library" sx={tabSx} />
                    <Tab label="Project Plans" sx={tabSx} />
                    <Tab label="Topics" sx={tabSx} />
                    <Tab label="Live" sx={tabSx} />
                </Tabs>
            </Container>

            <Container
                style={{
                    flex: 1,
                    minWidth: 0,
                    minHeight: 0,
                    overflow: 'hidden',
                }}
            >
                {selectedTab === ANALYSIS_TAB && (
                    <AnalysisTab
                        analyticsController={analyticsController}
                        trainingVideoController={TrainingVideoController}
                        projectPlanController={ProjectPlanController}
                        topics={topics}
                    />
                )}
                {selectedTab === VIDEO_LIBRARY_TAB && (
                    <VideoLibraryTab
                        trainingVideoController={TrainingVideoController}
                    />
                )}
                {selectedTab === PROJECT_PLANS_TAB && <ProjectPlansTab />}
                {selectedTab === TOPICS_TAB && <TopicsTab />}
                {selectedTab === LIVE_TAB && (
                    <LiveTab
                        onCreateProblem={analyticsController.createProblem}
                        onUpdateProblem={analyticsController.updateProblem}
                        onDeleteProblem={analyticsController.deleteProblem}
                        problemSaving={
                            analyticsController.createProblemLoading ||
                            analyticsController.updateProblemLoading ||
                            analyticsController.deleteProblemLoading
                        }
                    />
                )}
            </Container>
        </Container>
    )
}
